import { JSEncrypt } from "jsencrypt";
import { v4 as createUUID } from "uuid";
import { TripleDES, DES, HmacSHA1, SHA1, enc, mode, pad } from "crypto-js";

import axios from "axios";
import { LOGIN_CONSTANTS } from "../constants/app.constant";
import config from "../config/config";

// export default class AuthService {

export const encryptMessage = (payload, publickey) => {
  //generate random number
  const secretKey = createUUID();
  const stringifyPayload = JSON.stringify(payload);
  const currentTime = Date.now().toString();
  //DES encryption of payload
  const encryptedPayload = desEncryptMessage(stringifyPayload, secretKey);
  //DES encryption of timestamp
  const encryptedTimestamp = desEncryptMessage(currentTime, secretKey);
  //encrypt random key
  const encryptedKey = encryptSecretKey(secretKey, publickey);
  return {
    key: `data=${encodeURIComponent(
      encryptedPayload
    )}&key=${encryptedKey}&timestamp=${encodeURIComponent(encryptedTimestamp)}`,
  };
};

export const readPublicKey = () => {
  return axios({
    method: "GET",
    url: "https://assets.airtel.in/static-assets/airtel-lite/files/cert.pem",
  });
};

export const sendOtpApi = (payload) => {
  return axios({
    method: "POST",
    url: config.baseUrls.HELPSUPPORT.GUARDIAN_NEW_API+"sendOtp",
    data: payload,
  });
};


export const verifyOtp = (payload) => {
  return axios({
    method: "POST",
    url:
      config.baseUrls.HELPSUPPORT.GUARDIAN_NEW_API+"verifyOtp",
    data: payload,
  });
};

export const desEncryptMessage = (msg, secretKey) => {
  const keyHex = enc.Utf8.parse(secretKey);
  const encrypted = TripleDES.encrypt(msg, keyHex, {
    padding: pad.Pkcs7,
    mode: mode.ECB,
  });
  return encrypted.toString();
};

export const encryptSecretKey = (secretKey, publickey) => {
  const crypt = new JSEncrypt();
  crypt.setPublicKey(publickey);
  const enc = crypt.encrypt(secretKey);
  return encodeURIComponent(enc);
};

export const fetchPublicKey = async () => {
  const response = await readPublicKey();
  return response.data;
};

export const setTokensInLocalStorage = (authTokensData) => {
  localStorage.setItem(
    LOGIN_CONSTANTS.dynamicToken,
    authTokensData && authTokensData.dynamicToken
  );
  localStorage.setItem(LOGIN_CONSTANTS.uid, authTokensData && authTokensData.uid);
  localStorage.setItem(LOGIN_CONSTANTS.staticToken, authTokensData && authTokensData.staticToken);
  localStorage.setItem(
    LOGIN_CONSTANTS.loggedInUser,
    encodeData(authTokensData && authTokensData.loggedInUser)
  );
};

export const encodeData = (data) => {
  try {
    return btoa(encodeURIComponent(JSON.stringify(data)));
  } catch (error) {
    console.error(
      "utils-->encodeData-->Error occured while encoding data",
      error
    );
    return null;
  }
};

export const generateUTkn = (genParams) => {
  if (!genParams.method || !genParams.uri) return;
  const tokensDetail = {};
  const dataSTrKey = dataString(
    genParams.method,
    genParams.uri,
    genParams.params,
    genParams.body
  );
  const userIdAndTokensDetails = verifyOTPUserIdAndTokens();
  if (userIdAndTokensDetails.token) {
    var base64Key = HmacSHA1(dataSTrKey, userIdAndTokensDetails.token).toString(
      enc.Base64
    );
  }

  tokensDetail.dynamicToken = userIdAndTokensDetails.dynamicToken;
  const uTkn = `${userIdAndTokensDetails.uid}:${base64Key}`;
  tokensDetail.utkn = uTkn;
  return tokensDetail;
};

/**
 * Return Verified userId and tokens details
 * @returns {{dynamicToken: string, token: string, uid: string}}
 */
const verifyOTPUserIdAndTokens = () => {
  const details = {};
  details.dynamicToken = localStorage.getItem(LOGIN_CONSTANTS.dynamicToken);
  details.token = localStorage.getItem(LOGIN_CONSTANTS.staticToken);
  details.uid = localStorage.getItem(LOGIN_CONSTANTS.uid);
  return details;
};

/**
 * return encodeURI string
 * @param {string} str
 * @returns {string}
 */
const encodeURIString = (str) => {
  return encodeURIComponent(str);
};

/**
 * return api resource string
 * @param {string} method
 * @param {string} uri
 * @param {string} params
 * @param {*} body
 * @returns {string}
 */

const getStringifiedBodyData = (data) => {
  if (data instanceof Object) {
    if (Object.keys(data).length > 0) {
      return JSON.stringify(data);
    } else {
      return "";
    }
  }

  return data;
};

const dataString = (method, uri, params, body) => {
  let bodyData = getStringifiedBodyData(body);

  const url = new URL(decodeURIComponent(uri));
  const urlPathname = url && url.pathname;
  let urlParams = "";
  const paramsEntries = params && Object.entries(params);
  if (paramsEntries) {
    paramsEntries.forEach(([key, value]) => {
      const encodeValue = value;
      if (value != null || value != undefined) {
        if (!urlParams.length) {
          urlParams = `${key}=${encodeValue}`;
        } else {
          urlParams = `${urlParams}&${key}=${encodeValue}`;
        }
      }
    });
  }
  return `${method}${urlPathname}${params ? "?" : ""}${urlParams}${bodyData ||
    ""}`;
};
